import type { KnownMetadataKeys } from '~/domains/commissioner/channel/channel.enum';

// eslint-disable-next-line no-restricted-syntax
export enum ChannelType {
  PUBLIC = 'public',
  PRIVATE = 'private',
}

// eslint-disable-next-line no-restricted-syntax
export enum CommissionerAssetType {
  AVATAR = 'avatar',
  BACKDROP = 'backdrop',
}

export interface ChannelOnboardingPayload {
  name?: string;
  description?: string;
  handle?: string;
  color?: string;
  visibility?: ChannelType;
  avatarId?: string;
  avatarUrl?: string;
  backdropId?: string;
  backdropUrl?: string;
  tosAccepted?: boolean;
  metadata?: {
    [KnownMetadataKeys.LEAGUES]?: string[];
    [KnownMetadataKeys.CONTEST_TYPES]?: string[];
    [KnownMetadataKeys.AVERAGE_ENTRY_FEE]?: number;
    [KnownMetadataKeys.AVERAGE_CONTEST_SIZE]?: number;
  };
}

export interface Channel extends ChannelOnboardingPayload {
  id: string;
  slug: string;
  userId: string;
  receiveRewards: boolean;
  commissionerTier?: number;
  username?: string; // ? made up. Use real property for this
  createdAt: Date;
  updatedAt: Date;
  followersCount: number;
  followingCount: number;
  contestsCount: number;
  entriesCount: number;
  handle?: string;
  isFollowed?: boolean;
  followsMe?: boolean;
  verified?: boolean;
  isSplashAccount?: boolean;
  tosAccepted?: boolean;
}

export interface GetChannelResponse {
  data: Channel;
}
